import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { useMemo } from 'react';
import { SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME } from '../../../../../../define/consts/seminar/seminar_information';
import { propArrayShape, propNumber, propShape, propStr, } from '../../../../../../helpers/custom-prop-types';
import DateText from '../../../../../Ui/Common/DateText';
import SeminarDatesToolTip from '../../../../../Ui/Seminar/SeminarDatesToolTip';
/**
 * セミナーの日程を表示する
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const ProfessionalMyPageTopMySeminarItemDate = (props) => {
    const { adjustSchedule, className, dates, scheduleDate: rawScheduleDate, } = props;
    // 随時開催か
    const isAnytime = adjustSchedule === SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME.value;
    const { hasOtherDates, scheduleDate } = useMemo(() => {
        const lastIndex = dates.length - 1;
        // 直近の開催日付
        const date = rawScheduleDate || dates[lastIndex];
        return {
            // 「他実施日程あり」として表示すべき日付が存在するか
            hasOtherDates: dates.filter((v) => v.id !== date.id).length > 0,
            scheduleDate: date,
        };
    }, [dates, rawScheduleDate]);
    // 随時開催でない、かつ日付が未入力の場合は何も表示させない
    if (!isAnytime && !scheduleDate) {
        return null;
    }
    return (_jsxs("div", Object.assign({ className: clsx('professional_mypage_top_seminar_item_date', className) }, { children: [_jsx("div", Object.assign({ className: 'date_left' }, { children: "\u958B\u50AC\u65E5\uFF1A" })), _jsx("div", Object.assign({ className: 'date_right' }, { children: isAnytime ? (SEMINAR_INFORMATION_ADJUST_SCHEDULE_ANYTIME.label) : (_jsxs(_Fragment, { children: [_jsxs("div", Object.assign({ className: 'right_range' }, { children: [(scheduleDate === null || scheduleDate === void 0 ? void 0 : scheduleDate.startDate) && (_jsx("span", Object.assign({ className: 'range_start' }, { children: _jsx(DateText, { format: 'YYYY年MM月DD日(ddd) HH:mm', value: scheduleDate === null || scheduleDate === void 0 ? void 0 : scheduleDate.startDate }) }))), ((scheduleDate === null || scheduleDate === void 0 ? void 0 : scheduleDate.startDate) || (scheduleDate === null || scheduleDate === void 0 ? void 0 : scheduleDate.endDate)) && (_jsx("span", Object.assign({ className: 'range_separator' }, { children: "-" }))), (scheduleDate === null || scheduleDate === void 0 ? void 0 : scheduleDate.endDate) && (_jsx("span", Object.assign({ className: 'range_end' }, { children: _jsx(DateText, { format: (scheduleDate === null || scheduleDate === void 0 ? void 0 : scheduleDate.isSameDay)
                                            ? 'HH:mm'
                                            : 'YYYY年MM月DD日(ddd) HH:mm', value: scheduleDate === null || scheduleDate === void 0 ? void 0 : scheduleDate.endDate }) })))] })), hasOtherDates && (_jsx(SeminarDatesToolTip, { className: 'other_tooltip', dates: dates }))] })) }))] })));
};
ProfessionalMyPageTopMySeminarItemDate.propTypes = {
    adjustSchedule: propNumber(),
    className: propStr(),
    dates: propArrayShape(),
    scheduleDate: propShape(),
};
ProfessionalMyPageTopMySeminarItemDate.defaultProps = {
    adjustSchedule: null,
    className: '',
    dates: [],
    scheduleDate: null,
};
export default ProfessionalMyPageTopMySeminarItemDate;
